var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Cookies from 'js-cookie';
import dayjs from 'dayjs';
var HEADER_NAME = process.env.MARKETS_HEADER_NAME || 'X-Auth-Token';
var BROWSER_AUTH_COOKIE = process.env.BROWSER_AUTH_COOKIE || 'MARKETS_TOKEN';
var apiRequest = function (url, args) { return __awaiter(void 0, void 0, void 0, function () {
    var token, optionsConfig, formdata, request, authHeader, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                token = Cookies.get(BROWSER_AUTH_COOKIE);
                optionsConfig = {
                    method: (args === null || args === void 0 ? void 0 : args.method) ? args.method : 'get',
                    credentials: 'include',
                    headers: {},
                };
                if (token) {
                    optionsConfig.headers.authorization = "Bearer ".concat(token);
                }
                if (args === null || args === void 0 ? void 0 : args.method) {
                    optionsConfig.body = JSON.stringify(__assign({}, args === null || args === void 0 ? void 0 : args.body));
                }
                if (args === null || args === void 0 ? void 0 : args.file) {
                    formdata = new FormData();
                    formdata.append('image', args.file);
                    optionsConfig.body = formdata;
                }
                else {
                    optionsConfig.headers['Content-Type'] = 'application/json; charset=UTF-8';
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 6, , 7]);
                return [4 /*yield*/, fetch("/api/".concat(url), optionsConfig).catch(function (err) {
                        return err;
                    })];
            case 2:
                request = _a.sent();
                authHeader = request.headers.get(HEADER_NAME);
                if (authHeader) {
                    Cookies.set(BROWSER_AUTH_COOKIE, authHeader, {
                        expires: dayjs().add(2, 'hour').toDate(),
                    });
                }
                if (!(request.status !== 200)) return [3 /*break*/, 4];
                return [4 /*yield*/, request.json()];
            case 3: return [2 /*return*/, _a.sent()];
            case 4: return [4 /*yield*/, request.json()];
            case 5: return [2 /*return*/, _a.sent()];
            case 6:
                err_1 = _a.sent();
                return [2 /*return*/, err_1];
            case 7: return [2 /*return*/];
        }
    });
}); };
export default apiRequest;
